import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getRankingsByEvent, setRankingsByEvent } from "./rankings.service";

const rankingsKey = "jeep-rally-rankings";

export const useGetRankingsByEvent = (
  eventId,
  params = {},
  options = {}
) => {
  const categoryId = params?.categoryId || "";
  const afterStage =
    params?.after_stage === 0 || params?.after_stage
      ? String(params.after_stage)
      : "";

  return useQuery({
    queryKey: [rankingsKey, eventId, categoryId, afterStage],
    queryFn: () => {
      const query = { categoryId };
      if (afterStage !== "") {
        query.after_stage = Number(afterStage);
      }
      return getRankingsByEvent(eventId, query);
    },
    enabled:
      Boolean(eventId) &&
      Boolean(categoryId) &&
      options.enabled !== false,
    ...options,
  });
};

export const useSetRankingsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ eventId, payload }) =>
      setRankingsByEvent(eventId, payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [rankingsKey] });
      if (variables?.eventId) {
        queryClient.invalidateQueries({
          queryKey: [rankingsKey, variables.eventId],
        });
      }
    },
  });
};
